// These are used on the frontend and the backend
export const COMPLETE_ONBOARDING = 'complete_onboarding';
export const CUSTOMIZE_VIDEO_NAME = 'customize_video_name';
export const FILLED_ACCOUNT_SETTINGS = 'filled_account_settings';
export const FIRST_CAM_RECORDING = 'first_cam_recording';
export const FIRST_VIDEO_RECORDING = 'first_video_recording';
export const FIRST_VIDEO_UPLOAD = 'first_video_upload';
export const FIRST_VIDEO_VIEWED = 'first_video_viewed';
export const FOLLOWED_US_ON_TWITTER = 'followed_us_on_twitter';
export const LIKED_US_ON_FACEBOOK = 'liked_us_on_facebook';
export const PUSH_NOTIFICATION_ENABLED = 'push_notification_enabled';
export const SHARED_FIRST_VIDEO_ON_FACEBOOK = 'shared_first_video_on_facebook';
export const TWEETED_FIRST_VIDEO = 'tweeted_first_video';
export const HAS_VIEWED_VIDEOS = 'has_viewed_videos';
export const HAS_VIEWED_SCREENSHOTS = 'has_viewed_screenshots';
export const HAS_REACHED_RECORDING_LIMIT = 'has_reached_recording_limit';

// Frontend Only Variables
export const EMAIL_VERIFIED_FRONTEND_ONLY = 'email_verified';
export const GMAIL_INTEGRATED_FRONTEND_ONLY = 'gmail_integrated';
export const SLACK_APP_ADDED_FRONTENT_ONLY = 'slack_app_added';
export const CREATE_ACCOUNT = 'create_account';
export const DOWNLOAD_RECORDER = 'download_recorder';
export const SHARE_VIDEO = 'share_video';
export const ADD_TEAMMATE = 'add_teammate';

// checklist on get-started page
export const CHECKLIST = [
  FIRST_VIDEO_RECORDING,
  COMPLETE_ONBOARDING,
  EMAIL_VERIFIED_FRONTEND_ONLY,
  CUSTOMIZE_VIDEO_NAME,
  // determines first video view and first share checklist items
  FIRST_VIDEO_VIEWED,
  PUSH_NOTIFICATION_ENABLED,
];

// Export all variables that are used on both frontend and backend
export const ALL = [
  COMPLETE_ONBOARDING,
  CUSTOMIZE_VIDEO_NAME,
  FILLED_ACCOUNT_SETTINGS,
  FIRST_CAM_RECORDING,
  FIRST_VIDEO_RECORDING,
  FIRST_VIDEO_UPLOAD,
  FOLLOWED_US_ON_TWITTER,
  LIKED_US_ON_FACEBOOK,
  SHARED_FIRST_VIDEO_ON_FACEBOOK,
  TWEETED_FIRST_VIDEO,
  FIRST_VIDEO_VIEWED,
  PUSH_NOTIFICATION_ENABLED,
  SLACK_APP_ADDED_FRONTENT_ONLY,
  HAS_VIEWED_VIDEOS,
  HAS_VIEWED_SCREENSHOTS,
  HAS_REACHED_RECORDING_LIMIT,
  CREATE_ACCOUNT,
  DOWNLOAD_RECORDER,
  SHARE_VIDEO,
  ADD_TEAMMATE,
];

// new checklist variables
export const HAS_ACTIVATED_CHROME_EXTENSION = 'has_activated_chrome_extension';
export const HAS_ACTIVATED_DESKTOP_APP = 'has_activated_desktop_app';

export const NEW_GET_STARTED_CHECKLIST = [
  HAS_ACTIVATED_CHROME_EXTENSION,
  FIRST_VIDEO_RECORDING,
  FIRST_VIDEO_VIEWED,
];

export const GET_STARTED_CHECKLIST = [
  CREATE_ACCOUNT,
  DOWNLOAD_RECORDER,
  FIRST_VIDEO_RECORDING,
  SHARE_VIDEO,
  FIRST_VIDEO_VIEWED,
  ADD_TEAMMATE,
];
